module.exports = __webpack_public_path__ + "static/banner-footer-update-data-bo-MB-a25fe993f47a093e7c6118ee8ca40765.png";